/**
 * Copy Icon Component
 * Reusable SVG icon for copy actions
 */
import React from "react";
import PropTypes from "prop-types";

const CopyIcon = ({
  size = 20,
  color = "currentColor",
  className = "",
  ...props
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M6 2h9a2 2 0 012 2v9h-2V4H6V2zm-3 4h9a2 2 0 012 2v9a2 2 0 01-2 2H3a2 2 0 01-2-2V8a2 2 0 012-2zm0 2v9h9V8H3z"
        fill={color}
      />
    </svg>
  );
};

CopyIcon.propTypes = {
  size: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
};

export default CopyIcon;
